module.exports = __webpack_public_path__ + "static/media/visual-studio-code.e60fcd09.svg";